import { z } from 'zod'

export const validationSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: 'Nome é obrigatório' })
      .refine(
        value => {
          const names = value.trim().split(' ')
          const fewNames = names.length <= 1
          if (fewNames) return false
          return true
        },
        { message: 'Por favor, insira nome completo sem abreviações' }
      ),
    email: z
      .string()
      .email({ message: 'E-mail inválido' })
      .min(1, { message: 'E-mail é obrigatório' }),
    email_confirmation: z
      .string()
      .email({ message: 'E-mail inválido' })
      .min(1, { message: 'E-mail é obrigatório' }),
    password: z
      .string()
      .min(8, { message: 'Digite no mínimo 8 caracteres' })
      .max(128, { message: 'Digite no máximo 128 caracteres' })
      .regex(/^\S*$/, { message: 'Senha não pode conter espaços' }),
    password_confirmation: z
      .string()
      .min(1, { message: 'Confirmação de senha é obrigatória' }),
    birthdate: z
      .string()
      .transform(val => new Date(val))
      .refine(date => !isNaN(date.getTime()), { message: 'Data inválida' })
      .refine(
        date => {
          const today = new Date()
          const minAge = 14

          const maxBirthDate = new Date(
            today.getFullYear() - minAge,
            today.getMonth(),
            today.getDate()
          )

          return date <= maxBirthDate
        },
        { message: 'É necessário ter pelo menos 14 anos para se cadastrar' }
      ),
    school_id: z.number().min(1, { message: 'Escola é obrigatória' }),
    school_year: z.number({
      required_error: 'Série é obrigatória',
      invalid_type_error: 'Série é obrigatória'
    }),
    accept_terms: z.literal(true, {
      errorMap: () => ({
        message: 'Antes de continuar, aceite os Termos de Uso'
      })
    }),
    team_invite_qr_code: z.string().optional()
  })
  .superRefine((data, ctx) => {
    if (data.email_confirmation !== data.email) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['email_confirmation'],
        message: 'E-mails devem estar iguais'
      })
    }
    if (data.password_confirmation !== data.password) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['password_confirmation'],
        message: 'Senhas devem estar iguais'
      })
    }
  })
